import {View} from '@fantasmagames/slot/src/common/view/View';
import {ObjectSize, Position, Scale} from '@fantasmagames/slot/src/modules/reels/ReelConstants';
import {SpineAnimation} from '@fantasmagames/core/src/display/SpineAnimation';

export class OverTopReelEffectsView extends View {
	protected _isInFreeSpins: boolean = false;

	protected _currentMask: PIXI.Graphics;

	public init(): void {
		super.init();

		this._currentMask = new PIXI.Graphics();

		const scale: Scale = this.layout.getScale('BOTTOM_REEL_MASK');
		const noScaleSize: ObjectSize = this.layout.getSize('BOTTOM_REEL_MASK');
		const maskSize: ObjectSize = {width: noScaleSize.width * scale.x, height: noScaleSize.height * scale.y};
		const maskPos: Position = this.layout.getAbsolutePosition('BOTTOM_REEL_MASK');

		this._currentMask.drawRect(0, 0, 1, 1);

		this._currentMask.x = maskPos.x - maskSize.width / 2;
		this._currentMask.y = maskPos.y - maskSize.height / 2 - 150;
		this._currentMask.width = maskSize.width;
		this._currentMask.height = 150;
	}

	public playOrdinaryDropOn(dropRows: number): void {
		if (dropRows > 0) {
			const animationName: string = this._isInFreeSpins ? `FREESPIN_DROP_0${dropRows}` : `DROP_0${dropRows}`;

			const animation: SpineAnimation = this.spineUtils.startSpineAnimationCreation('ROW_DIVIDER_EFFECT.json', animationName, false)
				.position(this.layout.getAbsolutePosition(`ROW_DIVIDER_03`))
				.createAndStart();

			animation.container.mask = this._currentMask;

		}
	}

	public playSpecialDropIn(dropRows: number): void {
		if (dropRows > 0) {
			const animationName: string = this._isInFreeSpins ? `FREESPIN_SPECIAL_DROP_0${dropRows}` : `SPECIAL_DROP_0${dropRows}`;

			const animation: SpineAnimation = this.spineUtils.startSpineAnimationCreation('ROW_DIVIDER_EFFECT.json', animationName, false)
				.position(this.layout.getAbsolutePosition(`ROW_DIVIDER_03`))
				.createAndStart();

			animation.container.mask = this._currentMask;
		}
	}

	public set isInFreeSpins(value: boolean) {
		this._isInFreeSpins = value;
	}
}



// WEBPACK FOOTER //
// ./src/overtopreel/OverTopReelEffectsView.ts